import React from 'react';
import { Info, X } from 'lucide-react';

const INFO_HEADINGS = [
  'Budget Optimization Recommendations',
  'Business Problem:',
  'What it Solves:',
  'Business Value:',
  'Key Insight:',
  'Views:',
  '📋 COLUMN DEFINITIONS',
  '📊 Total Budget',
  '💰 Total Spend',
  '💵 Remaining Budget',
  '📈 % Budget Remaining',
  '🎯 Recommended Budget',
  '📊 Expected Incremental PTs',
  '💲 Cost/PT',
  '🎨 Saturation %',
  'Saturation %',
  '🚀 Headroom',
];

const InfoPopup = ({ isOpen, onClose, title, content }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-6 z-50">
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-3xl max-h-[80vh] overflow-y-auto">
        <div className="sticky top-0 bg-mongodb-green-dark2 text-white p-4 rounded-t-lg flex items-center justify-between">
          <h3 className="text-lg font-bold flex items-center gap-2">
            <Info className="w-5 h-5" />
            {title}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-1 transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6">
          <div className="prose prose-sm max-w-none text-mongodb-gray-dark3 whitespace-pre-wrap text-left">
            {String(content).split('\n').map((line, idx) => {
              const trimmed = line.trimStart();
              const isHeading = INFO_HEADINGS.some((h) => trimmed.startsWith(h));
              const isDivider = /[\u2500\u2550]{8,}/.test(line);
              const classNames = isHeading ? 'font-bold mt-4 mb-2' : isDivider ? 'my-3' : 'mb-1';
              return (
                <div key={idx} className={classNames}>
                  {line}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPopup;
